import { userTimeZoneFormat } from 'utils/time'

export function getFieldValue (field, userTimeZone) {
  let fieldText
  if (field.fieldType === 'datetime') {
    fieldText = field.value ? userTimeZoneFormat(userTimeZone, field.value) || '' : ''
  } else {
    fieldText = field.value || ''

    if (fieldText instanceof Array) {
      fieldText = fieldText.join(', ')
    } else if (typeof fieldText === 'object') {
      fieldText = ''
    }
  }
  return fieldText
}

export function getInitialValues (fields, parentTicket) {
  const initialValues = {}
  fields.forEach(field => {
    initialValues[field.name] = field.value
  })

  if (parentTicket) {
    const { number, title } = parentTicket
    initialValues.parent = {
      value: number,
      label: number + ' ' + title,
    }
  }

  return initialValues
}
